<template lang="pug">
  main
    Navbar
    section.section
      .container
        .columns
          .column.is-12.has-text-centered
            h1.is-size-5.title.has-text-dark
              span Estado actual del mundo 🌐&nbsp
        .columns
          .column.is-10.has-text-centered
            Mapa(:countries="datosPaises" @countrySel="countrySel")
          .column.is-2.has-text-centered
            PanelData(
              :dataGereral="dataGral")
            CardPais(:country='paisSelect' v-show="verPaisData")
        .columns.column-blanco
    Footer
</template>

<script>
import Mapa from './Mapa.vue'
import Navbar from './Navbar.vue'
import Footer from './Footer.vue'
import PanelData from './PanelData.vue'
import CardPais from './CardPais.vue'

export default {
  name: 'Container',
  components: {
    Mapa,
    Navbar,
    Footer,
    PanelData,
    CardPais,
  },
  data() {
    return {
      datosPaises: [],
      dataGral: {},
      paisSelect: {},
      verPaisData: false,
    }
  },
  watch: {
    paisSelect() {
      if (Object.keys(this.paisSelect).length > 0) {
        this.verPaisData = true
      } else {
        this.verPaisData = false
      }
    },
  },
  methods: {
    iniciarComponente() {
      this.renderData()
      this.renderDataGral()
    },
    async getData() {
      const response = await fetch('https://wuhan-coronavirus-api.laeyoung.endpoint.ainize.ai/jhu-edu/latest')
      const data = await response.json()
      return data
    },
    async renderData() {
      const dataCompleta = await this.getData()
      dataCompleta.forEach((item) => {
        if (item.confirmed > 0) {
          this.datosPaises.push(item)
        }
      })
    },
    async getDataGral() {
      const response = await fetch('https://wuhan-coronavirus-api.laeyoung.endpoint.ainize.ai/jhu-edu/brief')
      const data = await response.json()
      return data
    },
    async renderDataGral() {
      this.dataGral = await this.getDataGral()
    },
    countrySel(pais) {
      this.paisSelect = pais
    },
  },
  created() {
    this.iniciarComponente()
  },
}
</script>

<style lang="css" scoped>
  .container {
    margin-top: 10px;
  }
  .column-blanco {
    padding-bottom: 80px;
  }
</style>
